import { he } from './he';
import { en } from './en';
import type { Dictionary, TranslationKey } from './he';

export type { Dictionary, TranslationKey };

export interface LocaleDef {
    readonly id: string;
    /** שם השפה בשפה עצמה — לעולם לא מתורגם. */
    readonly name: string;
    readonly dir: 'rtl' | 'ltr';
    /** ל-toLocaleDateString / Intl.NumberFormat. */
    readonly localeCode: string;
    readonly dict: Dictionary;
}

/*
 * הוספת שפה = שלושה דברים בלבד:
 *   1. קובץ מילון חדש (למשל ru.ts) המוקלד Dictionary
 *   2. רשומה אחת בטבלה הזו
 *   3. הכיוון שלה ב-public/lang-boot.js
 * src/i18n/i18n.test.ts אוכף את שלושתם.
 */
export const LOCALES = {
    he: { id: 'he', name: 'עברית', dir: 'rtl', localeCode: 'he-IL', dict: he },
    en: { id: 'en', name: 'English', dir: 'ltr', localeCode: 'en-US', dict: en },
} as const satisfies Record<string, LocaleDef>;

export type LocaleId = keyof typeof LOCALES;

export const LOCALE_IDS = Object.keys(LOCALES) as readonly LocaleId[];

export const DEFAULT_LOCALE: LocaleId = 'he';

/** חייב להיות זהה למפתח ב-public/lang-boot.js. */
export const LANG_STORAGE_KEY = 'cf_lang';

export function isLocaleId(value: unknown): value is LocaleId {
    return typeof value === 'string' && Object.prototype.hasOwnProperty.call(LOCALES, value);
}

export type FormatParams = Readonly<Record<string, string | number>>;

/** מחליף {placeholder} בערכים. placeholder לא ידוע נשאר כמו שהוא במקום להיעלם. */
export function format(template: string, params: FormatParams): string {
    return template.replace(/\{(\w+)\}/g, (match, name: string) =>
        Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : match,
    );
}

export function translate(locale: LocaleId, key: TranslationKey, params?: FormatParams): string {
    const raw = LOCALES[locale].dict[key];
    return params ? format(raw, params) : raw;
}
